<template>
	<div class="goods-type" v-if="goodsData">
		<template v-for="(item, index) in goodsData">
			<a v-if="item.groupid == 7" :href="item.android_action.split('::')[1]" :key="index" data-stat="首页今日优品_头图">
				<img :src="item.customImgUrl" :alt="item.title" />
			</a>
		</template>
		<!-- <div class="list-wrap"> -->
		<div class="list-wrap" v-if="goodsData.length > 0">
			<van-grid :border="false" :column-num="3" gutter="5">
				<template v-for="(item, index) in goodsData">
					<van-grid-item v-if="item.groupid == 8" :key="index" class="list_jryp" :data-index="index">
						<van-image lazy-load class="pic" :src="item.customImgUrl" :alt="item.title" :data-stat="'首页今日优品_' + item.listingId" @click="goPage(item.listingId,item,index)">
							<template v-slot:loading>
								<van-loading type="spinner" size="20" />
							</template>
						</van-image>

						<p class="title van-multi-ellipsis--l2">{{ item.title }}</p>
						<p class="price">
							<span class="sell">{{ item.salePrice | currency }}</span>
						</p>
						<div class="bottom-btn">
							<van-button size="small" round color="linear-gradient(to right, #FF7D43, #FE3247)" :data-stat="'首页今日优品_立即购买_' + item.listingId" @click="goPage(item.listingId,item,index)"
								>立即购买</van-button
							>
							<van-icon
								:name="require('../assets/img/icon-share.png')"
								size="1.5rem"
								:data-stat="'首页今日优品_分享_' + item.listingId"
								@click="share(item.title, item.title, link + item.listingId, item.customImgUrl, item.listingId, item.salePrice)"
							/>
						</div>
					</van-grid-item>
				</template>
			</van-grid>
		</div>
		<slot></slot>
		<shareTip :showTip="showTip" @hideTip="showTip = false" />
	</div>
</template>

<script>
import shareTip from "@/components/shareTip.vue";
import {scExposure} from "@/libs/common.js"
export default {
	name: "goodsType",
	components: { shareTip },
	props: {
		goodsData: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			link: `https://h5.${this.$uleUrl()}/yxd/community/item/itemPage/`,
			showTip: false,
			goodsDatas: [],
			shareId: "",
		};
	},
	mounted() {
		let _this=this;
		scExposure(".list_jryp",function(index){
			let ylyx_resource_forward_url='';
			if (_this.$route.query.name) {
				ylyx_resource_forward_url=`/item/itemPage/${_this.goodsData[index].listingId}?name=${_this.$route.query.name}&latng=${_this.$route.query.latng}&addr=${_this.$route.query.addr}&city=${_this.$route.query.city}&module=${_this.$route.query.module}&freshActType=${_this.freshActType}`
			} else {
				ylyx_resource_forward_url=`/item/itemPage/${_this.goodsData[index].listingId}?freshActType=${_this.freshActType}`
			}
			window.uleStatUtil && window.uleStatUtil.sendSensorTrack("ylyx_ResourceExposure", {
				ylyx_resource_ower:'非试点版',
				ylyx_resource_type: '今日优品',
				ylyx_resource_content: _this.goodsData[index].title || '',
				ylw_resource_out_position: 2,
				ylw_resource_inner_position: (+index + 1),
				ylyx_resource_item_type: '商品',
				ylyx_resource_item_id: _this.goodsData[index].listingId,
				ylyx_resource_forward_url: ylyx_resource_forward_url,
			});
		});//监听资源位曝光
	},
	methods: {
		goPage(listId,item,index) {
			this.$emit("showVi", listId);
			let ylyx_resource_forward_url='';
			if (this.$route.query.name) {
				ylyx_resource_forward_url=`/item/itemPage/${listId}?name=${this.$route.query.name}&latng=${this.$route.query.latng}&addr=${this.$route.query.addr}&city=${this.$route.query.city}&module=${this.$route.query.module}&freshActType=${this.freshActType}`
			} else {
				ylyx_resource_forward_url=`/item/itemPage/${listId}?freshActType=${this.freshActType}`
			}
			window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_ResourceClick', {
				ylyx_resource_ower: '非试点版',
				ylyx_resource_type: '今日优品',
				ylyx_resource_content: item.title,
				ylw_resource_out_position: 2,
				ylw_resource_inner_position: (+index + 1),
				ylyx_resource_item_type: '商品',
				ylyx_resource_item_id: listId,
				ylyx_resource_forward_url: ylyx_resource_forward_url,
			});
		},
		share(title, desc, link, img, listingId, price) {
			this.goodsShare(title, desc, link, img, listingId, price, price);
		},
	},
};
</script>

<style scoped lang="scss">
.goods-type {
	position: relative;
	margin: 0 10px 10px;
	border-radius: 7px 7px 0 0;
	background: #fff;
	> a img {
		border-radius: 6px 6px 0 0;
	}
	.list-wrap {
		padding: 5px 2px 10px;
		.pic {
			width: 110px;
			height: 110px;
			border-radius: 6px;
		}
		p {
			padding: 0 5px;
		}
		.title {
			margin: 5px auto 8px;
			height: 2rem;
			line-height: 20px;
			font-size: 11px;
			color: #333;
		}
		.price {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: baseline;
			margin-bottom: 3px;
			font-size: 11px;

			.make,
			.sell {
				color: #ec3d3f;
			}
		}
		.bottom-btn {
			width: 100%;
			padding: 0 3px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			align-content: space-between;
			button {
				width: 70px;
				height: 17px;
				font-size: 11px;
				line-height: 19px;
			}
			.van-icon {
				float: right;
			}
		}
	}
}
</style>
